<template lang="pug">
#PersonalIdentity
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Personal Identity" :HeaderGlobalBreadcrumb="breadcrumb")

    //- end

    .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading Personal Data
                        //- span(v-if="personal_identity.person && personal_identity.person['@match']") (match: {{ String(personal_identity.person['@match']) }})
                .header-cta.flex.items-center
                    //- router-link.link-text(to="#") Visit account

        .box__body.p-4
            template(v-if="load_data_status_personal_identity.status === 'loading'")
                Loading(show="true")

            template(v-else)

                //- .block.mb-4(v-if="personal_identity.person && Object.keys(personal_identity.person).length > 0 && typeof personal_identity.possible_persons === 'undefined' ")
                .block.mb-4
                    .flex.flex-wrap.-mx-4   
                        .block.px-4(class="w-full lg:w-1/3")
                            .block.mb-4
                                span.text-light Name
                                //- h3.monospace {{ profile_identity.name ? profile_identity.name : '-' }}
                                h3.monospace
                                    //- router-link.link-text(v-if="personal_identity.person && personal_identity.person.names && personal_identity.person.names[0] && personal_identity.person.names[0].display && personal_identity.person.names[0].display.length > 0" :to="'/search-by-name/'+ encrypt(personal_identity.person.names[0].display, 'name')" target="_blank")
                                        | {{ personal_identity.person.names[0].display }}

                                    template(v-if="personal_identity.person && personal_identity.person.names && personal_identity.person.names.length > 0")
                                        span(v-for="name,index_name in personal_identity.person.names") {{ name.display ? (name.display + ((index_name+1) != personal_identity.person.names.length ? ', ' : '')) : '-' }}

                                    template(v-else) -

                            .block.mb-4
                                span.text-light MSISDN
                                h3.monospace
                                    //- template(v-if="personal_identity.person && personal_identity.person.phones && personal_identity.person.phones[0] && personal_identity.person.phones[0].number && personal_identity.person.phones[0].number.toString().length > 0")
                                        //- router-link.link-text(v-for="msisdn in personal_identity.phone" :to="'/result/'+ encrypt(msisdn +'&&msisdn') +'/recent-location'" target="_blank") {{ msisdn }}
                                        router-link.link-text(:to="'/result/'+ encrypt(personal_identity.person.phones[0].country_code.toString() + personal_identity.person.phones[0].number.toString() +'&&msisdn') +'/recent-location'" target="_blank") {{ personal_identity.person.phones[0].country_code.toString() + personal_identity.person.phones[0].number.toString() }}
                                    template(v-if="personal_identity.person && personal_identity.person.phones && personal_identity.person.phones.length > 0")
                                        span(v-for="phone,index_phone in personal_identity.person.phones") {{ phone.number && phone.number.toString() ? (phone.country_code.toString() + phone.number.toString() + ((index_phone+1) != personal_identity.person.phones.length ? ', ' : '')) : '-' }}
                                    template(v-else) -

                            .block.mb-4
                                span.text-light Email
                                h3.monospace
                                    template(v-if="personal_identity.person && personal_identity.person.emails && personal_identity.person.emails.length > 0")
                                        span(v-for="email,index_email in personal_identity.person.emails") {{ email.address ? (email.address + ((index_email+1) != personal_identity.person.emails.length ? ', ' : '')) : '-' }}

                                    template(v-else) -


                        .block.px-4(class="w-full lg:w-1/3")
                            .block.mb-4
                                span.text-light Gender
                                h3.monospace {{ personal_identity.person && personal_identity.person.gender && personal_identity.person.gender.content && personal_identity.person.gender.content.length > 0 ? personal_identity.person.gender.content : '-' }}
                            .block.mb-4
                                span.text-light Address
                                h3.monospace 
                                    template(v-if="personal_identity.person && personal_identity.person.addresses && personal_identity.person.addresses.length > 0")
                                        span(v-for="address,index_address in personal_identity.person.addresses") {{ address.display ? (address.display + ((index_address+1) != personal_identity.person.addresses.length ? ', ' : '')) : '-' }}

                                    template(v-else) -

                            .block.mb-4
                                span.text-light Language
                                h3.monospace
                                    template(v-if="personal_identity.person && personal_identity.person.languages && personal_identity.person.languages.length > 0")
                                        span(v-for="language,index_language in personal_identity.person.languages") {{ language.language ? (language.language + ((index_language+1) != personal_identity.person.languages.length ? ', ' : '')) : '-' }}

                                    template(v-else) -


                        .block.px-4(class="w-full lg:w-1/3")
                            .block.mb-4
                                span.text-light Username
                                h3.monospace
                                    template(v-if="personal_identity.person && personal_identity.person.usernames && personal_identity.person.usernames.length > 0")
                                        span(v-for="username,index_username in personal_identity.person.usernames") {{ username.content ? (username.content + ((index_username+1) != personal_identity.person.usernames.length ? ', ' : '')) : '-' }}

                                    template(v-else) -

                            .block.mb-4
                                span.text-light Job
                                h3.monospace
                                    template(v-if="personal_identity.person && personal_identity.person.jobs && personal_identity.person.jobs.length > 0")
                                        span(v-for="job,index_job in personal_identity.person.jobs") {{ job.display ? (job.display + ((index_job+1) != personal_identity.person.jobs.length ? ', ' : '')) : '-' }}

                                    template(v-else) -

                            .block.mb-4
                                span.text-light Match
                                h3.monospace {{ personal_identity.person && personal_identity.person['@match'] ? personal_identity.person && personal_identity.person['@match'] : '-' }}
                            



                    //- .grid.grid-cols-3.gap-6(v-if="personal_identity && personal_identity.person && Object.keys(personal_identity.person).length > 0")
                        .box(style="margin-bottom: 0px")
                            .box__header.no-border
                                header.flex.items-center.justify-between
                                    .header-meta
                                        h2.subheading Facebook
                                    .header-cta.flex.items-center
                                        //- router-link.link-text(to="#") Visit account
                            .box__body.p-4
                                .block.mb-4
                                    span.block.mb-1 URL
                                    router-link.link-text.block(to="#" target="_blank") Arief Gunawan
                                .block.mb-4
                                    span.block.mb-1 Name
                                    .block.text-white Arief Gunawan
                                .block.mb-4
                                    span.block.mb-1 Phone number
                                    router-link.link-text.block(to="#" target="_blank") 08122280745339

                                .block.mb-4
                                    span.block.mb-1 Address
                                    .block.text-white Jl Arjuna no. 123, Kec Badung, Kabupaten Bandung, Jawa Barat.

                                .block
                                    span.block.mb-1 Hobby
                                    .block.text-white footabll, Basketball, Renang, Mancing


                //- NoDataAvailable(v-else)
                //- NoDataAvailable

    
    .grid.grid-cols-4.gap-8(v-if="load_data_status_personal_identity.status !== 'loading' && personal_identity.person && personal_identity.person.urls && personal_identity.person.urls.length > 0")
        .box(style="margin-bottom: 0px" v-for="link in personal_identity.person.urls")
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ link['@domain'] }}
                    .header-cta.flex.items-center
                        //- router-link.link-text(to="#") Visit account
            .box__body.p-4
                .block.mb-4
                    span.block.mb-1 URL
                    //- router-link.link-text.block(to="#" target="_blank") Arief Gunawan
                    a.link-text.block(:href="link.url" target="_blank") {{ link.url }}
                //- .block.mb-4
                //-     span.block.mb-1 Name
                //-     .block.text-white Arief Gunawan
                //- .block.mb-4
                //-     span.block.mb-1 Phone number
                //-     router-link.link-text.block(to="#" target="_blank") 08122280745339

                //- .block.mb-4
                //-     span.block.mb-1 Address
                //-     .block.text-white Jl Arjuna no. 123, Kec Badung, Kabupaten Bandung, Jawa Barat.

                //- .block
                    span.block.mb-1 Hobby
                    .block.text-white footabll, Basketball, Renang, Mancing

    //- ============================================================================================================================

    .grid.grid-cols-4.gap-8(v-if="personal_identity.possible_persons && personal_identity.possible_persons.length > 0")
        .box(style="margin-bottom: 0px;" v-for="person in personal_identity.possible_persons")
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Match
                    .header-cta.flex.items-center
                        //- router-link.link-text(to="#") Visit account
                        //- span {{ person['@match'] || person['@match'] === 0 ? person['@match'] : '-' }}
                        span {{ person['@match'] || person['@match'].length !== 0 ? Number.parseFloat(person['@match'] * 100) + ' %' : '-' }}

            .box__body.p-4
                //- .block.mb-4
                    span.block.mb-1 Match
                    router-link.link-text.block(to="#" target="_blank") {{ person['@match'] ? person['@match'] : '-' }}
                    
                //- first name & last name
                //- template(v-if="keyword_type.name_arr && keyword_type.name_arr.length > 1")
                .block.mb-4
                    span.block.mb-1 Names
                    .block.text-white
                        template(v-if="person.names && person.names.length > 0")
                            span(v-for="name,index_name in person.names") {{ name.display ? (name.display + ((index_name+1) != person.names.length ? ', ' : '')) : '-' }}
                        template(v-else) -

                .block.mb-4
                    span.block.mb-1 Usernames
                    .block.text-white
                        template(v-if="person.usernames && person.usernames.length > 0")
                            span(v-for="username,index_username in person.usernames") {{ username.content ? (username.content + ((index_username+1) != person.usernames.length ? ', ' : '')) : '-' }}
                        template(v-else) -
                
                .block.mb-4
                    span.block.mb-1 Gender
                    .block.text-white {{ person.gender && person.gender.content ? person.gender.content : '-' }}

                .block.mb-4
                    span.block.mb-1 DOB
                    .block.text-white {{ person.dob && person.dob.display && person.dob.date_range.start ? person.dob.date_range.start +' ('+ person.dob.display +')' : '-' }}

                .block.mb-4
                    span.block.mb-1 Languages
                    .block.text-white
                        template(v-if="person.languages && person.languages.length > 0")
                            span(v-for="language,index_language in person.languages") {{ language.display ? (language.display + ((index_language+1) != person.languages.length ? ', ' : '')) : '-' }}
                        template(v-else) -

                .block.mb-4
                    span.block.mb-1 Phones
                    .block.text-white
                        template(v-if="person.phones && person.phones.length > 0")
                            span(v-for="phone,index_phone in person.phones") {{ phone.number && phone.number.toString() ? (phone.country_code.toString() + phone.number.toString() + ((index_phone+1) != person.phones.length ? ', ' : '')) : '-' }}
                        template(v-else) -

                .block.mb-4
                    span.block.mb-1 Addresses
                    .block.text-white
                        template(v-if="person.addresses && person.addresses.length > 0")
                            span(v-for="address,index_address in person.addresses") {{ address.display ? (address.display + ((index_address+1) != person.addresses.length ? ', ' : '')) : '-' }}
                        template(v-else) -

                .block.mb-4
                    span.block.mb-1 Educations
                    .block.text-white
                        template(v-if="person.educations && person.educations.length > 0")
                            span(v-for="education,index_education in person.educations") {{ education.display ? (education.display + ((index_education+1) != person.educations.length ? ', ' : '')) : '-' }}
                        template(v-else) -

                .block.mb-4
                    span.block.mb-1 Relationships
                    .block.text-white
                        template(v-if="person.relationships && person.relationships.length > 0")
                            //- span(v-for="relationship,index_relationship in person.relationships") {{ relationship.display ? (relationship.display + ((index_relationship+1) != person.relationships.length ? ', ' : '')) : '-' }}
                            span(v-for="relationship,index_relationship in person.relationships")
                                template(v-if="relationship.names && relationship.names.length > 0")
                                    span(v-for="relation,index_relation in relationship.names")
                                        | {{ relation.display ? (relation.display + (relationship['@subtype'] ? ' ('+ relationship['@subtype'] +')' : ' ('+ relationship['@type'] +')' ) + ((index_relation+1) != relationship.length ? ', ' : '')) : '-' }}
                        template(v-else) -

                .block
                    span.block.mb-1 Image
                    .block.text-white
                        template(v-if="person.images && person.images.length > 0")
                            img(v-for="image in person.images" :src="image.url" @error="imgError($event)")
                        span(v-else) -

    //- ---------------------------------------------------------------------------------------------------------------

    //- .grid.grid-cols-3.gap-6
        .box(style="margin-bottom: 0px")
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Facebook
                    .header-cta.flex.items-center
                        //- router-link.link-text(to="#") Visit account
            .box__body.p-4
                .block.mb-4
                    span.block.mb-1 URL
                    router-link.link-text.block(to="#" target="_blank") Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Name
                    .block.text-white Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Phone number
                    router-link.link-text.block(to="#" target="_blank") 08122280745339

                .block.mb-4
                    span.block.mb-1 Address
                    .block.text-white Jl Arjuna no. 123, Kec Badung, Kabupaten Bandung, Jawa Barat.

                .block
                    span.block.mb-1 Hobby
                    .block.text-white footabll, Basketball, Renang, Mancing

        .box(style="margin-bottom: 0px")
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Instagram
                    .header-cta.flex.items-center
                        //- router-link.link-text(to="#") Visit account
            .box__body.p-4
                .block.mb-4
                    span.block.mb-1 URL
                    router-link.link-text.block(to="#" target="_blank") Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Name
                    .block.text-white Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Phone number
                    router-link.link-text.block(to="#" target="_blank") 08122280745339

                .block.mb-4
                    span.block.mb-1 Address
                    .block.text-white Jl Arjuna no. 123, Kec Badung, Kabupaten Bandung, Jawa Barat.

                .block
                    span.block.mb-1 Hobby
                    .block.text-white footabll, Basketball, Renang, Mancing

        .box(style="margin-bottom: 0px")
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading LinkedIn
                    .header-cta.flex.items-center
                        //- router-link.link-text(to="#") Visit account
            .box__body.p-4
                .block.mb-4
                    span.block.mb-1 URL
                    router-link.link-text.block(to="#" target="_blank") Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Name
                    .block.text-white Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Phone number
                    router-link.link-text.block(to="#" target="_blank") 08122280745339

                .block.mb-4
                    span.block.mb-1 Address
                    .block.text-white Jl Arjuna no. 123, Kec Badung, Kabupaten Bandung, Jawa Barat.

                .block.mb-4
                    span.block.mb-1 Pekerjaan
                    .block.text-white Kerjaan A

                .block
                    span.block.mb-1 Pengalaman
                    .block.text-white Pengalaman A

        .box(style="margin-bottom: 0px")
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Twitter
                    .header-cta.flex.items-center
                        //- router-link.link-text(to="#") Visit account
            .box__body.p-4
                .block.mb-4
                    span.block.mb-1 URL
                    router-link.link-text.block(to="#" target="_blank") Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Name
                    .block.text-white Arief Gunawan
                .block.mb-4
                    span.block.mb-1 Phone number
                    router-link.link-text.block(to="#" target="_blank") 08122280745339

                .block.mb-4
                    span.block.mb-1 Address
                    .block.text-white Jl Arjuna no. 123, Kec Badung, Kabupaten Bandung, Jawa Barat.

                .block
                    span.block.mb-1 Hobby
                    .block.text-white footabll, Basketball, Renang, Mancing


</template>

<script>
import HeaderGlobal from '../../components/HeaderGlobal.vue'
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { encrypt } from '@/util/crypto';

export default {
    name: 'PersonalIdentity',
    components: {
        HeaderGlobal,
        Loading,
        NoDataAvailable,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Personal Identity',
                    url: '/result/personal-identity',
                },
            ],
        };
    },
    computed: {
        ...mapState([
            'load_data_status_personal_identity',
            'personal_identity',
        ]),
    },
    watch: {
        // load_data_status_personal_identity(newData) {
        //     console.log('watch load_data_status_personal_identity')
        //     console.log(newData)
        // },
        // personal_identity(newData) {
        //     console.log('watch personal_identity')
        //     console.log(newData)
        // },
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        encrypt(key, type) {
            return encrypt(key+ '&&' +type);
        },
        imgError(e) {
            e.target.classList.add('hide-img')
            // console.log(url)
        },
    },
}
</script>

<style lang="sass" scoped="">
    .hide-img
        display: none
</style>
